var fixRoutingOnLoaded = false;

var app = new Framework7({    
    root: "#app",
    name: "Braas",
    theme: 'md',
    view: {
        pushState: true,
        pushStateSeparator:"",
        pushStateOnLoad:true
    },
    routes: [
        {
            path: '(.*)',
            async: function(routeTo, routeFrom, resolve, reject) {
                if (fixRoutingOnLoaded) {
                    Framework7.request.get(
                        routeTo.url, 
                        function (data) {
                            resolve({content: data });
                        }, 
                        function(xhr, status){
                            if (status == 404) {
                                resolve({content: xhr.responseText});
                            }
                        })
                } else {
                    fixRoutingOnLoaded = true;
                }
            },
            on: {
                pageInit: function (e, page) {
                    Render.do(page.el);
                },
            }
        }
    ]
});


Popup.init();


var svgLoaderCallback = function(){
    svgToInline.load(this);
}
Render.add('.svg', svgLoaderCallback);


Render.add('.advantages .swiper-container', function(){

        var swiperAdvantages = app.swiper.create($(this), {
        speed: 400,
        spaceBetween: 10,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
    });

    swiperAdvantages.on('slideChange', function () {
      $(".advantages .advantages--icon")
              .removeClass("active")
              .eq(this.realIndex).addClass("active");
    });

    });


Render.add('.shop--model_swiper', function(){
    let self = this;
    setTimeout(function(){
        app.swiper.create($(self), {
            direction: 'vertical'
        });
    }, 200);
});


Render.add('.model__colors', function(){

        var swiper = app.swiper.create($(this), {
        spaceBetween: 9,
        slidesPerView: 'auto',
        centeredSlides: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });

    function change() {
       var url = $(".item-color", swiper.slides[swiper.realIndex]).data("url");
        Associated.load(url, $(swiper.el).closest('.page').find(".model__associated"));
    }

    swiper.on('slideChange', change);
    change();

    });

var actionProducts;
Render.add('.actionProducts', function(){
    var buttons = [];

            $(this).find("a").each(function(){
        var self = this;
        buttons.push({
            text: $(this).text(),
            color: $(this).data("color"),
            onClick: function () {
                app.views.main.router.navigate($(self).attr("href"));
            }
        });
    })

    actionProducts = app.actions.create({
        buttons: [
          buttons,
          [{text: 'Отмена'}]
        ]
    });
});

$('body').on('click', '.actionsProducts--trigger', function () {
    actionProducts.open();
}); 


Render.add('table', function(){

    if (!$(this).hasClass("table__content") && this.closest('.table__skip') == null) {
        var divNode = document.createElement("div"),
            table = this.cloneNode(true),
            divInnerNode = document.createElement("div");

        divNode.setAttribute('class', 'table');
        divInnerNode.setAttribute('class', 'table__inner');
        table.classList.add('table__content');
        divInnerNode.appendChild(table);
        divNode.appendChild(divInnerNode);
        this.parentNode.replaceChild(divNode, this);
    }
});


Render.add('.pb-container', function(){
    var photos = [];
    $("a.pb-photo", this).each(function(){
        if ($(this).attr("href")) {
            photos.push($(this).attr("href"));
        }
    });

        var photoBrowser = app.photoBrowser.create({
        photos : photos,
        routableModals: false,
        backLinkText: '',
        theme: 'dark',
        pageBackLinkText: 'Назад',
        popupCloseLinkText: 'Закрыть'

            });
    $(this).on('click', '.pb-photo', function (e) {
        e.preventDefault();
        var index = [].indexOf.call($(this).closest('.pb-container').find('.pb-photo'), this);
        photoBrowser.open(index);
    });
})


if (navigator.share) {
    $("html").addClass("share-enable");
    $("body").on("click", ".share", function(){
        var url = $(this).data("url");
        if (url.indexOf('/') === 0 && url.indexOf('//') === -1) {
            url = window.location.origin + url;
        }
        navigator.share({
            title: $(this).data("title"),
            url: url,
        });
    });
}


Render.add('.lazy', function(){
    app.lazy.create(this)
});

$(document).on("infinite", ".infinite-scroll-content", function(){
    var self = this;
    let $next = $('.infinite-scroll-next', this);
    if ($next.length) {
        let url = $next.attr("href");
        $next.remove();
        if (url) {
            url += (!~url.indexOf('?') ? '?' : '&') + '_=' + Date.now();
            app.request.get(url, function (data) {
                let $html = $('<div>' + data + '</div>');
                let $preloader = $(self).find('.infinite-scroll-preloader');

                                if ($html.find(".infinite-scroll-content").length) {
                    $($html.find(".infinite-scroll-content").html()).insertBefore($preloader);
                    Render.do(self);
                }

                                $preloader.remove();
            });
        }
    }
})

$("body").on("click", ".like:not(.liked)[data-url]", function(){
    var self = $(this);
    Framework7.request.get(
        $(this).data("url"),
        (data) => {
            var response = JSON.parse(data);
            self.addClass("liked");
            if (response.count) {
                self.find(".like_count").html(response.count);
            }
            else self.removeClass("liked");
        }
    );

});

if (!Cookies.get('not_first')) {
    Cookies.set('not_first', 1, {path: '/', expires: 3600 * 24 * 30});
    $("html").addClass("first_visit");
}


window.addEventListener("load", function(){
  Render.do();  
});
